// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/icons/calendar.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-selector {
  position: relative;
  width: 100%;
  background-color: #ffffff;
  border-radius: 8px;
}
.date-selector .disableCover {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  background-color: rgba(0, 0, 0, 0.2);
}
.date-selector__container {
  display: flex;
  flex-direction: row;
  width: 100%;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
}
.date-selector__container .disableButtonContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30%;
  min-width: 100px;
  border-left: 1px solid #ddd;
}
.date-selector__custom-input {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 96% center;
  width: var(--width);
  height: var(--height);
  padding-left: 10px;
  border: 0;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
  cursor: pointer;
}
.date-selector__label {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}

.react-datepicker__aria-live {
  display: none;
}

.react-datepicker {
  font-size: 1rem;
}

.react-datepicker__header {
  padding-top: 0.8rem;
}

.react-datepicker__month {
  margin: 0.4rem 1rem;
}

.react-datepicker__day-name, .react-datepicker__day {
  width: 1.9rem;
  line-height: 1.9rem;
  margin: 0.166rem;
}

.react-datepicker__current-month {
  font-size: 1rem;
}

.react-datepicker__navigation {
  top: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/common/date-selector/date-selector.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AACJ;AACI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,8BAAA;EACA,oCAAA;AACN;AAEI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EAEA,yBAAA;EACA,kBAAA;AADN;AAGM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;EACA,2BAAA;AADR;AAKI;EACI,wEAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAJR;AAOI;EACE,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AALN;;AASA;EACI,aAAA;AANJ;;AASA;EACI,eAAA;AANJ;;AAQE;EACE,mBAAA;AALJ;;AAOE;EACE,mBAAA;AAJJ;;AAME;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAHJ;;AAKE;EACE,eAAA;AAFJ;;AAIE;EACE,WAAA;AADJ","sourcesContent":[".date-selector {\n    position: relative;\n    width: 100%;\n    background-color: #ffffff;\n    border-radius: 8px;\n\n    .disableCover {\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      border-top-left-radius: 8px;\n      border-bottom-left-radius: 8px;\n      background-color: rgba(0,0,0,0.2);\n    }\n\n    &__container {\n      display: flex;\n      flex-direction: row;\n      width: 100%;\n\n      border: 1px solid #e9e9e9;\n      border-radius: 8px;\n\n      .disableButtonContainer {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 30%;\n        min-width: 100px;\n        border-left: 1px solid #ddd;\n      }\n    }\n\n    &__custom-input {\n        background: url('../../assets/icons/calendar.svg') no-repeat 96% center;\n        width: var(--width);\n        height: var(--height);\n        padding-left: 10px;\n        border: 0;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24px;\n        color: #333333;\n        cursor: pointer;\n    }\n\n    &__label {\n      font-family: 'Spoqa Han Sans Neo';\n      font-style: normal;\n      font-weight: 700;\n      font-size: 14px;\n      line-height: 20px;\n      color: #505054;\n    }\n}\n\n.react-datepicker__aria-live {\n    display: none;\n}\n\n.react-datepicker {\n    font-size: 1rem;\n  }\n  .react-datepicker__header {\n    padding-top: 0.8rem;\n  }\n  .react-datepicker__month {\n    margin: 0.4rem 1rem;\n  }\n  .react-datepicker__day-name, .react-datepicker__day {\n    width: 1.9rem;\n    line-height: 1.9rem;\n    margin: 0.166rem;\n  }\n  .react-datepicker__current-month {\n    font-size: 1rem;\n  }\n  .react-datepicker__navigation {\n    top: 0.5rem;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
